export default __webpack_public_path__ + "static/media/Avatar-14-noback.c9bea333.png";